/**
 * @desc ToB客户审批信息-详情
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<defs.basics.BusinessCustomerChangeDetailResponseDto>;
export function request(instanceId: string, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/businessCustomer/changeDetail/${instanceId}`, {
      method: "GET",

      ...options,
    }),
  );
}
